import { GET_ORG_EMAIL_SETTINGS, UPDATE_ORG_EMAIL_SETTINGS } from '../../types'
import { trackPromise } from 'react-promise-tracker'
import log from 'loglevel'
const api = (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'http:' ? 'http://' + window.location.hostname + ':3080' : (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'https:' ? 'https://' + window.location.hostname + ':8443' : process.env.REACT_APP_API_URL

export const getOrgEmailTemplates = () => {
  return async function (dispatch, getState) {
    const { token, accountId } = getState().auth

    const options = {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/email`, options))

    if (!response.status || response.status === 404 || response.status === 401 || response.status === 500) {
      log.warn('non 200 status code from account emails')
    } else {
      const { data } = await response.json()
      const [template] = data
      const welcomeEmailTemplate = JSON.parse(template.welcomeEmailTemplate)
      const alertEmailTemplate = JSON.parse(template.alertEmailTemplate)
      const sourceEmailAddress = template.sourceEmailAddress
      const sourceEmailName = template.sourceEmailName
      const results = { welcomeEmailTemplate, alertEmailTemplate, sourceEmailAddress, sourceEmailName }
      dispatch({
        type: GET_ORG_EMAIL_SETTINGS,
        payload: results
      })
    }
  }
}

export const updateOrgEmailTemplates = (welcomeEmailTemplate, alertEmailTemplate, sourceEmailAddress, sourceEmailName, fireSuccess, fireFailure) => {
  return async function (dispatch, getState) {
    const { token, accountId } = getState().auth

    const body = { welcomeEmailTemplate, alertEmailTemplate, sourceEmailAddress, sourceEmailName }

    const options = {
      method: 'PUT',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/email`, options))
    if (!response.status || response.status === 500 || response.status === 400 || response.status === 401 || response.status === 404) {
      fireFailure()
    } else {
      fireSuccess()
      dispatch({
        type: UPDATE_ORG_EMAIL_SETTINGS,
        payload: { ...body }
      })
    }
  }
}
